import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_sales_order_filter_drown",
  ref: "draftOrderRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-950px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_sales_order_filter_drown_header"
}
const _hoisted_5 = { class: "fw-bolder" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "fs-6 text-gray-400" }, null, -1)
const _hoisted_7 = {
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_8 = { class: "svg-icon svg-icon-1" }
const _hoisted_9 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = {
  key: 0,
  class: "col-md-6 form-group mb-7"
}
const _hoisted_12 = { class: "form-label fw-bold" }
const _hoisted_13 = {
  key: 1,
  class: "col-md-6 form-group mb-7"
}
const _hoisted_14 = { class: "form-label fw-bold" }
const _hoisted_15 = {
  key: 2,
  class: "col-md-6 form-group mb-7"
}
const _hoisted_16 = { class: "form-label fw-bold" }
const _hoisted_17 = { class: "col-md-6 form-group mb-7" }
const _hoisted_18 = { class: "form-label fw-bold" }
const _hoisted_19 = { class: "col-md-6 form-group mb-7" }
const _hoisted_20 = { class: "form-label fw-bold" }
const _hoisted_21 = { class: "col-md-6 form-group mb-7" }
const _hoisted_22 = { class: "form-label fw-bold" }
const _hoisted_23 = { class: "col-md-6 form-group mb-7" }
const _hoisted_24 = { class: "form-label fw-bold" }
const _hoisted_25 = { class: "col-md-6 form-group mb-7" }
const _hoisted_26 = { class: "form-label fw-bold" }
const _hoisted_27 = { class: "col-md-6 form-group mb-7" }
const _hoisted_28 = { class: "form-label fw-bold" }
const _hoisted_29 = { class: "col-md-6 form-group mb-7" }
const _hoisted_30 = { class: "form-label fw-bold" }
const _hoisted_31 = { class: "modal-footer align-items-center justify-content-end gap-2 max-sm-justify-content-center" }
const _hoisted_32 = { class: "svg-icon svg-icon-3" }
const _hoisted_33 = { class: "svg-icon svg-icon-3" }
const _hoisted_34 = {
  class: "menu menu-sub menu-sub-dropdown w-250px w-md-600px",
  "data-kt-menu": "true"
}
const _hoisted_35 = { class: "px-7 py-5" }
const _hoisted_36 = { class: "fs-5 text-dark fw-bolder" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "separator border-gray-200" }, null, -1)
const _hoisted_38 = { class: "px-7 py-5" }
const _hoisted_39 = { class: "row" }
const _hoisted_40 = {
  key: 0,
  class: "col-md-6 form-group mb-7"
}
const _hoisted_41 = { class: "form-label fw-bold" }
const _hoisted_42 = {
  key: 1,
  class: "col-md-6 form-group mb-7"
}
const _hoisted_43 = { class: "form-label fw-bold" }
const _hoisted_44 = {
  key: 2,
  class: "col-md-6 form-group mb-7"
}
const _hoisted_45 = { class: "form-label fw-bold" }
const _hoisted_46 = { class: "col-md-6 form-group mb-7" }
const _hoisted_47 = { class: "form-label fw-bold" }
const _hoisted_48 = { class: "col-md-6 form-group mb-7" }
const _hoisted_49 = { class: "form-label fw-bold" }
const _hoisted_50 = { class: "col-md-6 form-group mb-7" }
const _hoisted_51 = { class: "form-label fw-bold" }
const _hoisted_52 = { class: "col-md-6 form-group mb-7" }
const _hoisted_53 = { class: "form-label fw-bold" }
const _hoisted_54 = { class: "col-md-6 form-group mb-7" }
const _hoisted_55 = { class: "form-label fw-bold" }
const _hoisted_56 = { class: "col-md-6 form-group mb-7" }
const _hoisted_57 = { class: "form-label fw-bold" }
const _hoisted_58 = { class: "col-md-6 form-group mb-7" }
const _hoisted_59 = { class: "form-label fw-bold" }
const _hoisted_60 = { class: "d-flex justify-content-end" }
const _hoisted_61 = {
  type: "submit",
  class: "btn btn-sm btn-primary",
  "data-kt-menu-dismiss": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_window_resize = _resolveComponent("window-resize")!

  return (_openBlock(), _createBlock(_component_window_resize, null, {
    sm: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_form, {
            ref: "formRef",
            model: _ctx.formData
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", null, [
                    _createElementVNode("h2", _hoisted_5, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.t("common.filterOptions")), 1)
                    ]),
                    _hoisted_6
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("span", _hoisted_8, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    (_ctx.props.showType === 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.t("salesOrder.status")) + ":", 1),
                          _createVNode(_component_el_form_item, { prop: "status" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.formData.status,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.status) = $event)),
                                clearable: "",
                                multiple: "",
                                "collapse-tags": "",
                                placeholder: _ctx.t('common.plsSelect'),
                                style: {"width":"100%"}
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.status, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.value,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "placeholder"])
                            ]),
                            _: 1
                          })
                        ]))
                      : (_ctx.props.showType === 2)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.t("salesOrder.status")) + ":", 1),
                            _createVNode(_component_el_form_item, { prop: "status" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.formData.status,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.status) = $event)),
                                  clearable: "",
                                  multiple: "",
                                  placeholder: _ctx.t('common.plsSelect'),
                                  style: {"width":"100%"}
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.selectStatus, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.value,
                                        label: item.label,
                                        value: item.value
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "placeholder"])
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true),
                    (_ctx.props.showType === 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.t("salesOrder.settlementStatus")) + ":", 1),
                          _createVNode(_component_el_form_item, { prop: "settlement_status" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.formData.settlement_status,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.settlement_status) = $event)),
                                clearable: "",
                                multiple: "",
                                placeholder: _ctx.t('common.plsSelect'),
                                style: {"width":"100%"}
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.mb_order_settlement_status, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.value,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "placeholder"])
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.t("salesOrder.customer")) + ":", 1),
                      _createVNode(_component_el_form_item, { prop: "customer_id" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            ref: "selectCustomer",
                            onFocus: _ctx.cancelReadonly,
                            "onHook:mounted": _ctx.cancelReadonly,
                            onVisibleChange: _ctx.cancelReadonly,
                            teleported: false,
                            modelValue: _ctx.formData.customer_id,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.customer_id) = $event)),
                            filterable: "",
                            clearable: "",
                            "remote-show-suffix": "",
                            remote: "",
                            placeholder: _ctx.t('common.plsEnter'),
                            "remote-method": _ctx.searchCustomerItems,
                            loading: _ctx.options.customerLoading
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.customer, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["onFocus", "onHook:mounted", "onVisibleChange", "modelValue", "placeholder", "remote-method", "loading"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.t("salesOrder.priority")) + ":", 1),
                      _createVNode(_component_el_form_item, { prop: "priority_level" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.formData.priority_level,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.priority_level) = $event)),
                            clearable: "",
                            placeholder: _ctx.t('common.plsSelect'),
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.priority_level, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.t("salesOrder.orderDateStart")) + ":", 1),
                      _createVNode(_component_el_form_item, { prop: "order_date_start" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            class: "w-100",
                            modelValue: _ctx.formData.order_date_start,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.order_date_start) = $event)),
                            type: "date",
                            placeholder: _ctx.t('common.pickDate'),
                            teleported: false
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.t("salesOrder.orderDateEnd")) + ":", 1),
                      _createVNode(_component_el_form_item, { prop: "order_date_end" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            class: "w-100",
                            modelValue: _ctx.formData.order_date_end,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.order_date_end) = $event)),
                            type: "date",
                            placeholder: _ctx.t('common.pickDate'),
                            teleported: false
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.t("salesOrder.externalOrderNumber")) + ":", 1),
                      _createVNode(_component_el_form_item, {
                        prop: "external_order_number",
                        onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"]))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.external_order_number,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.external_order_number) = $event)),
                            type: "text",
                            placeholder: _ctx.t('common.plsEnter'),
                            clearable: ""
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.t("order.brand")) + ":", 1),
                      _createVNode(_component_el_form_item, { prop: "brand_id" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            class: "w-100",
                            ref: "selectBrand",
                            onFocus: _ctx.cancelReadonly,
                            "onHook:mounted": _ctx.cancelReadonly,
                            onVisibleChange: _ctx.cancelReadonly,
                            teleported: false,
                            modelValue: _ctx.formData.brand_id,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.brand_id) = $event)),
                            filterable: "",
                            clearable: "",
                            "remote-show-suffix": "",
                            remote: "",
                            "remote-method": _ctx.searchBrandSourceItems,
                            loading: _ctx.options.brandLoading,
                            placeholder: _ctx.t('common.plsSelect')
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.brand, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["onFocus", "onHook:mounted", "onVisibleChange", "modelValue", "remote-method", "loading", "placeholder"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.t("order.articleNoOther")) + ":", 1),
                      _createVNode(_component_el_form_item, {
                        prop: "article_no",
                        onClick: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop"]))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.article_no,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.article_no) = $event)),
                            type: "text",
                            clearable: "",
                            placeholder: _ctx.t('common.plsEnter')
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("button", {
                    type: "reset",
                    class: "btn btn-light",
                    "data-bs-dismiss": "modal",
                    onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.handleReset && _ctx.handleReset(...args)))
                  }, [
                    _createElementVNode("span", _hoisted_32, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr059.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.t("common.reset")), 1)
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-primary",
                    "data-bs-dismiss": "modal",
                    onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
                  }, [
                    _createElementVNode("span", _hoisted_33, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.t("common.apply")), 1)
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ], 512)
    ]),
    lg: _withCtx(() => [
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.t("common.filterOptions")), 1)
        ]),
        _hoisted_37,
        _createElementVNode("div", _hoisted_38, [
          _createVNode(_component_el_form, {
            ref: "formRef",
            onSubmit: _cache[27] || (_cache[27] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
            model: _ctx.formData
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_39, [
                (_ctx.props.showType === 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                      _createElementVNode("label", _hoisted_41, _toDisplayString(_ctx.t("salesOrder.status")) + ":", 1),
                      _createVNode(_component_el_form_item, { prop: "status" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.formData.status,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.status) = $event)),
                            clearable: "",
                            multiple: "",
                            "collapse-tags": "",
                            placeholder: _ctx.t('common.plsSelect'),
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.status, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ]))
                  : (_ctx.props.showType === 2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                        _createElementVNode("label", _hoisted_43, _toDisplayString(_ctx.t("salesOrder.status")) + ":", 1),
                        _createVNode(_component_el_form_item, { prop: "status" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.formData.status,
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.status) = $event)),
                              clearable: "",
                              multiple: "",
                              placeholder: _ctx.t('common.plsSelect'),
                              style: {"width":"100%"}
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.selectStatus, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.value,
                                    label: item.label,
                                    value: item.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "placeholder"])
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                (_ctx.props.showType === 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                      _createElementVNode("label", _hoisted_45, _toDisplayString(_ctx.t("salesOrder.settlementStatus")) + ":", 1),
                      _createVNode(_component_el_form_item, { prop: "settlement_status" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.formData.settlement_status,
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formData.settlement_status) = $event)),
                            clearable: "",
                            multiple: "",
                            placeholder: _ctx.t('common.plsSelect'),
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.mb_order_settlement_status, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("label", _hoisted_47, _toDisplayString(_ctx.t("salesOrder.customer")) + ":", 1),
                  _createVNode(_component_el_form_item, { prop: "customer_id" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        ref: "selectCustomer",
                        onFocus: _ctx.cancelReadonly,
                        "onHook:mounted": _ctx.cancelReadonly,
                        onVisibleChange: _ctx.cancelReadonly,
                        teleported: false,
                        modelValue: _ctx.formData.customer_id,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formData.customer_id) = $event)),
                        filterable: "",
                        clearable: "",
                        "remote-show-suffix": "",
                        remote: "",
                        placeholder: _ctx.t('common.plsEnter'),
                        "remote-method": _ctx.searchCustomerItems,
                        loading: _ctx.options.customerLoading,
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.customer, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["onFocus", "onHook:mounted", "onVisibleChange", "modelValue", "placeholder", "remote-method", "loading"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("label", _hoisted_49, _toDisplayString(_ctx.t("salesOrder.priority")) + ":", 1),
                  _createVNode(_component_el_form_item, { prop: "priority_level" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.priority_level,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formData.priority_level) = $event)),
                        clearable: "",
                        placeholder: _ctx.t('common.plsSelect'),
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.priority_level, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("label", _hoisted_51, _toDisplayString(_ctx.t("salesOrder.orderDateStart")) + ":", 1),
                  _createVNode(_component_el_form_item, { prop: "order_date_start" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        class: "w-100",
                        modelValue: _ctx.formData.order_date_start,
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.formData.order_date_start) = $event)),
                        type: "date",
                        placeholder: _ctx.t('common.pickDate'),
                        teleported: false
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("label", _hoisted_53, _toDisplayString(_ctx.t("salesOrder.orderDateEnd")) + ":", 1),
                  _createVNode(_component_el_form_item, { prop: "order_date_end" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        class: "w-100",
                        modelValue: _ctx.formData.order_date_end,
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.formData.order_date_end) = $event)),
                        type: "date",
                        placeholder: _ctx.t('common.pickDate'),
                        teleported: false
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("label", _hoisted_55, _toDisplayString(_ctx.t("salesOrder.externalOrderNumber")) + ":", 1),
                  _createVNode(_component_el_form_item, {
                    prop: "external_order_number",
                    onClick: _cache[22] || (_cache[22] = _withModifiers(() => {}, ["stop"]))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.external_order_number,
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.formData.external_order_number) = $event)),
                        type: "text",
                        placeholder: _ctx.t('common.plsEnter'),
                        clearable: ""
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_56, [
                  _createElementVNode("label", _hoisted_57, _toDisplayString(_ctx.t("order.brand")) + ":", 1),
                  _createVNode(_component_el_form_item, { prop: "brand_id" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        class: "w-100",
                        ref: "selectBrand",
                        onFocus: _ctx.cancelReadonly,
                        "onHook:mounted": _ctx.cancelReadonly,
                        onVisibleChange: _ctx.cancelReadonly,
                        teleported: false,
                        modelValue: _ctx.formData.brand_id,
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.formData.brand_id) = $event)),
                        filterable: "",
                        clearable: "",
                        "remote-show-suffix": "",
                        remote: "",
                        "remote-method": _ctx.searchBrandSourceItems,
                        loading: _ctx.options.brandLoading,
                        placeholder: _ctx.t('common.plsSelect')
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.brand, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["onFocus", "onHook:mounted", "onVisibleChange", "modelValue", "remote-method", "loading", "placeholder"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_58, [
                  _createElementVNode("label", _hoisted_59, _toDisplayString(_ctx.t("order.articleNoOther")) + ":", 1),
                  _createVNode(_component_el_form_item, {
                    prop: "article_no",
                    onClick: _cache[25] || (_cache[25] = _withModifiers(() => {}, ["stop"]))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.article_no,
                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.formData.article_no) = $event)),
                        type: "text",
                        clearable: "",
                        placeholder: _ctx.t('common.plsEnter')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_60, [
                _createElementVNode("button", {
                  type: "reset",
                  class: "btn btn-sm btn-light btn-active-light-primary me-2",
                  "data-kt-menu-dismiss": "true",
                  onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.handleReset && _ctx.handleReset(...args)))
                }, _toDisplayString(_ctx.t("common.reset")), 1),
                _createElementVNode("button", _hoisted_61, _toDisplayString(_ctx.t("common.apply")), 1)
              ])
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ])
    ]),
    _: 1
  }))
}